import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cache from 'i18next-localstorage-cache';
import postProcessor from 'i18next-sprintf-postprocessor';
import Backend from 'i18next-xhr-backend';
import environment from '../../environment';
import { i18nMixin } from '../../../modules/shared/mixins/i18n.mixin';
import { getCountry } from '../../../utils';

const _country = getCountry().toUpperCase();

export const translate = (text, properties) => {
    if (!properties) {
        const brand = environment.get('CONFIG.CLIENT') || '';
        const target = environment.get('CONFIG.TARGET') || '';
        properties = {
            bandeira: brand,
            target: String(target).replace(/_/g, '').replace(/MAISDE/, '>')
        };
    }

    let output = i18next.t(text, properties);

    if (output === text) {
        if (properties.empty) {
            output = '';
        }
    }

    return output;
};

export const translateText = (text, uppercase = false, capitalize = true) => {
    if (!text) {
        return text;
    }

    if (!capitalize) {
        return text;
    }

    const t = text
        .split(' ')
        .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
        .join(' ');

    return uppercase ? translate(t).toUpperCase() : translate(t);
};

translate.init = (callback) => {
    i18next
        .use(Backend)
        .use(Cache)
        .use(LanguageDetector)
        .use(postProcessor)
        .init({
            fallbackLng: `en-${i18nMixin.getLanguageMap(_country)}`,
            lng: translate.mountLanguage(),
            whitelist: [
                `en-${i18nMixin.getLanguageMap(_country)}`, 
                `pt-${i18nMixin.getLanguageMap(_country)}`,
                `es-${i18nMixin.getLanguageMap(_country)}`],
            backend: {
                loadPath: 'static/locales/{{lng}}.json'
            }
        }, callback);
};


translate.mountLanguage = () => {
    const lang = (localStorage.getItem('language') || 'pt-BR').split('-');
    return `${lang[0]}-${i18nMixin.getLanguageMap(_country)}`;
};

translate.language = () => i18next.language;

translate.changeLanguage = (lng) => i18next.changeLanguage(lng);

export default translate;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/translate.js